<template>
  <div class="wrapper">
    <div class="content">
      <Nav />
      <HotPush :list="list" />
      <LeftMenu :brandList="list"></LeftMenu>
    </div>
  </div>
</template>

<script>
import Nav from '@/views/layout/contentInfo/nav.vue'
import HotPush from './components/hotPush.vue'
import LeftMenu from './components/leftMenu.vue'

export default {
  components: {
    Nav,
    HotPush,
    LeftMenu
  },
  data () {
    return {
      list: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.$http
        .get(
          '/front/oms/openapi/shopping-content-information/category/first-list?includeInformation=true'
        )
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.list = (res.data || [])
              .map((item) => {
                return {
                  ...item,
                  informationList: item.informationList
                    ? item.informationList
                      .filter((info) => {
                        return !!info.id
                      })
                      .slice(0, 15)
                    : []
                }
              })
              .filter((item) => {
                return item.informationList.length > 0
              })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  background: #fff;
  font-family: Alibaba PuHuiTi;

  .content {
    width: 1200px;
    min-height: calc(80vh - 120px);
    // background: #eee;
  }
}
</style>
